import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { StagePlanGetSingleByStageIdSubStage, StagePlanGetSingleByStageIdSubStageResponse, SubStages } from '../../api/dtos';


const getData = (response?: SWRResponse<StagePlanGetSingleByStageIdSubStageResponse, StagePlanGetSingleByStageIdSubStageResponse>) => {
    return response?.data?.stagePlan
};
const getError = (response?: SWRResponse<StagePlanGetSingleByStageIdSubStageResponse, StagePlanGetSingleByStageIdSubStageResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useStagePlanByStageIdSubStage = (stageId?: number, subStage?: SubStages, configuration?: SWRConfiguration<StagePlanGetSingleByStageIdSubStageResponse, StagePlanGetSingleByStageIdSubStageResponse>) => {
    
    const request = useMemo(() => {
        return stageId ?
            () => {
                return new StagePlanGetSingleByStageIdSubStage({ stageId: stageId, subStage: subStage });
            } :
            undefined;
    }, [stageId, subStage])

    return useGet(request, { getData, getError }, configuration);
}

export default useStagePlanByStageIdSubStage;